


// import React from "react";
// import Tooltip from "@mui/material/Tooltip";
// import heartLoading from "../../assests/heartLoading.gif";
// import { ArrowUp, ArrowDown } from "lucide-react";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import { Search } from "lucide-react";
// import Skeleton from "@mui/material/Skeleton";



// const AssetTable = ({
//   tableData = [],
//   loading = false,
//   assetCount = 0,
//   error = null,
//   pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },

//   onPageChange = () => {},
//   onColumnSearchChange = () => {},   
//   columnSearch = {}, 
// }) => {
//   const items = [
//     { color: "#FB0301", label: "< 90%" },
//     { color: "#FFC100", label: "90% – 95%" },
//     { color: "#009F52", label: "≥ 95%" },
//   ];
//     const tableContainerRef = React.useRef(null);
  
// const renderHighlightedText = (text, searchTerm) => {
//   if (!searchTerm || !text) return text;

//   const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
//   return parts.map((part, i) =>
//     part.toLowerCase() === searchTerm.toLowerCase() ? (
//       <span key={i} style={{ backgroundColor: "orange", fontWeight: "500" }}>
//         {part}
//       </span>
//     ) : (
//       part
//     )
//   );
// };

//   // if (loading) {
//   //   return (
//   //     <div
//   //       className="flex items-center justify-center w-full overflow-hidden"
//   //       style={{ minHeight: "100%", marginTop: "80px" }}
//   //     >
//   //       <div className="text-center flex flex-col items-center justify-center space-y-4">
//   //         <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
//   //         <div className="space-y-2">
//   //           <p className="text-gray-700 text-xl font-semibold">
//   //             Applying filters...
//   //           </p>
//   //           <p className="text-gray-500 text-base">
//   //             Updating results based on your selection
//   //           </p>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // }

//   if (error) {
//     return <div className="p-4 text-red-600">Error: {error}</div>;
//   }

//   const totalRecords = pagination.totalCount || 0;
//   const pageSize = pagination.pageSize || 10;
//   const currentPage = pagination.page || 1;
//   const totalPages =
//     pagination.totalPages && pagination.totalPages > 0
//       ? pagination.totalPages
//       : Math.max(1, Math.ceil(totalRecords / pageSize));

//   const indexOfFirstRow =
//     totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
//   const indexOfLastRow =
//     totalRecords === 0 ? 0 : Math.min(currentPage * pageSize, totalRecords);

//   const gotoPage = (p) => {
//     const target = Math.max(1, Math.min(totalPages, p));
//     if (target !== currentPage) {
//       onPageChange(target);
//     }
//   };

//   return (
//     <div className="poppins-regular">
//       {/* Header count */}
//       {/* <div className="mb-[20px]">
//         <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
//           THERE ARE {assetCount} ASSETS FOUND
//         </span>
//       </div> */}

//       {/* Score legend */}
//       <div className="flex items-center justify-between w-full mb-4">
//         <div className="flex items-center space-x-8">
//           <div className="flex space-x-6">
//             {items.map((item, idx) => (
//               <div key={idx} className="flex items-center space-x-2">
//                 <div
//                   className="w-[14px] h-[50px] rounded-full"
//                   style={{ backgroundColor: item.color.trim() }}
//                 />
//                 <div className="flex flex-col text-sm text-gray-500">
//                   <span style={{ fontSize: "12px" }}>DQ Score</span>
//                   <span style={{ fontSize: "12px" }}>{item.label}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Pagination (your original code) */}
//         <div>
//           {totalRecords > 0 && (
//             <div className="pagination-controls flex items-center gap-2">
//               <button
//                 disabled={currentPage === 1}
//                 onClick={() => gotoPage(currentPage - 1)}
//                 className="px-3 py-1 border rounded disabled:opacity-50"
//               >
//                 Previous
//               </button>

//               {(() => {
//                 const pageButtons = [];
//                 const totalToShow = 5;

//                 let start = Math.max(
//                   1,
//                   currentPage - Math.floor(totalToShow / 2)
//                 );
//                 let end = start + totalToShow - 1;

//                 if (end > totalPages) {
//                   end = totalPages;
//                   start = Math.max(1, end - totalToShow + 1);
//                 }

//                 if (start > 1) pageButtons.push(1);
//                 if (start > 2) pageButtons.push("...");

//                 for (let i = start; i <= end; i++) {
//                   pageButtons.push(i);
//                 }

//                 if (end < totalPages - 1) pageButtons.push("...");
//                 if (end < totalPages) pageButtons.push(totalPages);

//                 return pageButtons.map((p, idx) =>
//                   p === "..." ? (
//                     <span key={idx} className="px-2">
//                       ...
//                     </span>
//                   ) : (
//                     <button
//                       key={idx}
//                       onClick={() => gotoPage(p)}
//                       className={`px-3 py-1 border rounded ${
//                         currentPage === p ? "bg-[#0000a0] text-white" : ""
//                       }`}
//                     >
//                       {p}
//                     </button>
//                   )
//                 );
//               })()}

//               <button
//                 disabled={currentPage === totalPages}
//                 onClick={() => gotoPage(currentPage + 1)}
//                 className="px-3 py-1 border rounded disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//         <div className="flex justify-between items-center">
//         {/* Left side items */}
//         <div className="flex items-center gap-3 mb-[10px]">
//           {/* Search Input */}
//           <div className="relative w-[200px] mt-[6px] flex-shrink-0">
//             <input
//               type="text"
//               className="text-[9px] placeholder-gray-400 py-2 pl-[10px] w-full outline-none border border-gray-500 rounded"
//               placeholder="Search..."
             
//             />
      
//             {/* Search Icon */}
//             <Search
//               size={14}
//               color="#9CA3AF"
//               className="absolute right-[8px] top-1/2 -translate-y-1/2 pointer-events-none"
//             />
//           </div>
      
//           {/* Reset button */}
//           <button className="px-3 mt-[4px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
        
//         >
//             Reset
//           </button>
      
//           {/* Scroll section */}
//        <div className="flex items-center gap-1 mt-[2px]">
//        <ChevronLeft
//         title="Scroll Left"
//           className="cursor-pointer"
//           onClick={() => {
//             if (tableContainerRef.current) {
//               tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
//             }
//           }}
//         />
//         <p className="text-[12px]">Scroll</p>
//         <ChevronRight
//           className="cursor-pointer"
//           title="Scroll Right"
//           onClick={() => {
//             if (tableContainerRef.current) {
//               tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
//             }
//           }}
//         />
//       </div>
      
//         </div>
      
//         {/* Right side - Export */}
//         <div className="mb-[10px]">
//         <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
//           THERE ARE {assetCount} UNIQUE A FOUND
//         </span>
//       </div>
//       </div>

//       {/* Table */}
// <div
//   ref={tableContainerRef}
//   className="w-full overflow-x-auto"
//   style={{ scrollBehavior: "smooth" }}
// >
//   <table
//     className="border-collapse border border-gray-200 text-sm"
//     style={{ minWidth: "max-content", tableLayout: "auto" }}
//   >
        
         
// <thead className="bg-[#9897FF1A] text-[#404040] font-medium">
//   {/* Header Row */}
//   <tr>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px]">
//       Domain
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px]">
//       Sub Domain
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[200px]">
//       Data Product Name
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[170px]">
//       Region
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px]">
//       Data Asset Name
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px]">
//       Frequency
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px]">
//       Execution Date
//     </th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px]">
//       Total DQ Score
//     </th>
//   </tr>

//   {/* Input Row */}
//   <tr>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Domain"
//           value={columnSearch.domain_name || ""}
//   onChange={(e) => onColumnSearchChange("domain_name", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Sub Domain"
//           value={columnSearch.sub_domain_name || ""}
//   onChange={(e) => onColumnSearchChange("sub_domain_name", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Data Product"
//           value={columnSearch.product_name || ""}
//   onChange={(e) => onColumnSearchChange("product_name", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Region"
//         value={columnSearch.region || ""}
//   onChange={(e) => onColumnSearchChange("region", e.target.value)}

//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Data Asset"
//           value={columnSearch.data_asset_name || ""}
//   onChange={(e) => onColumnSearchChange("data_asset_name", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Frequency"
//           value={columnSearch.frequency || ""}
//   onChange={(e) => onColumnSearchChange("frequency", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search Execution Date"
//           value={columnSearch.execution_date || ""}
//   onChange={(e) => onColumnSearchChange("execution_date", e.target.value)}
//       />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input
//         className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//         placeholder="Search DQ Score"
//           value={columnSearch.total_dq_score || ""}
//   onChange={(e) => onColumnSearchChange("total_dq_score", e.target.value)}
//       />
//     </th>
//   </tr>
// </thead>



//           <tbody>
//          {loading ? (
//     [...Array(5)].map((_, i) => (
//       <tr key={i}>
//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         {/* Data Asset Name */}
//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         {/* Frequency */}
//         <td className="px-[25px] py-2">
//           <Skeleton variant="text" width="100%" height={20} />
//         </td>

//         {/* Execution Date */}
//         <td className="px-[25px] py-2">
//           <Skeleton variant="text"width="100%" height={20} />
//         </td>

//         {/* Total DQ Score */}
//         <td className="px-[25px] py-2">
//           <Skeleton variant="rectangular"width="100%" height={20} />
//         </td>
//       </tr>
//     ))
//   ) : tableData.length === 0 ? (
//     <tr>
//       <td colSpan="8" className="text-center py-10 text-gray-500">
//         No Data Available
//       </td>
//     </tr>
//   ) : (
//               tableData.map((row, idx) => {
//                 const {
//                   domain,
//                   sub_domain,
//                   data_product_name,
//                   region,
//                   data_asset_name,
//                   frequency,
//                   execution_date,
//                   total_dq_score,
//                   uniqueness_qs,
//                   validity_qs,
//                   freshness_qs,
//                   consistency_qs,
//                   completeness_qs,
//                   accuracy_qs,
//                 } = row;

                
//                 let textColor = "black";
//                 let tooltipBgColor = "#fff";
//                 if (total_dq_score != null) {
//                   if (total_dq_score < 90) {
//                     textColor = "#FB0301";
//                     tooltipBgColor = "#f03e3eff";
//                   } else if (total_dq_score >= 90 && total_dq_score < 95) {
//                     textColor = "#FFC100";
//                     tooltipBgColor = "#FFC100";
//                   } else if (total_dq_score >= 95) {
//                     textColor = "#009F52";
//                     tooltipBgColor = "#009F52";
//                   }
//                 }

//                 const dateStr = execution_date
//                   ? new Date(execution_date).toLocaleDateString("en-US", {
//                       weekday: "short",
//                       month: "short",
//                       day: "numeric",
//                       year: "numeric",
//                     })
//                   : "-";

//                 return (
//                   <tr key={idx} className="hover:bg-[#E4F8F1] transition"
//                      style={{ backgroundColor: idx % 2 === 0 ? "white" : "#eee" }}
// >
// <td className="px-[25px] py-2">
//   {domain ? (
//     renderHighlightedText(
//       domain.length > 10 ? domain.slice(0, 10) + "..." : domain,
// columnSearch.domain_name    )
//   ) : (
//     "null"
//   )}
// </td>

// <td className="px-[25px] py-2">
//   {sub_domain ? (
//     renderHighlightedText(
//       sub_domain.length > 15 ? sub_domain.slice(0, 15) + "..." : sub_domain,
// columnSearch.sub_domain_name    )
//   ) : (
//     "null"
//   )}
// </td>
// <td className="px-[25px] py-2">
//   {data_product_name ? (
//     renderHighlightedText(
//       data_product_name.length > 15
//         ? data_product_name.slice(0, 15) + "..."
//         : data_product_name,
//      columnSearch.product_name
//     )
//   ) : (
//     "null"
//   )}
// </td>    <td className="px-[25px] py-2">
//   <Tooltip title={region || ""}>
//     <span className="truncate block w-[160px]">
//       {region
//         ? renderHighlightedText(region,columnSearch.region)
//         : "null"}
//     </span>
//   </Tooltip>
// </td>

//                   <td className="px-[25px] py-2">
//   <Tooltip title={data_asset_name || ""}>
//     <span className="truncate block w-[180px]">
//       {data_asset_name
//         ? renderHighlightedText(data_asset_name,columnSearch.data_asset_name)
//         : "null"}
//     </span>
//   </Tooltip>
// </td>
//                   <td className="px-[25px] py-2">
//   <span className="w-[160px]">
//     {frequency
//       ? renderHighlightedText(frequency, columnSearch.frequency)
//       : "null"}
//   </span>
// </td>

// <td className="px-[25px] py-2">
//   {dateStr
//     ? renderHighlightedText(dateStr, columnSearch.execution_date)
//     : "null"}
// </td>      
// <td className="px-[25px] py-2 font-semibold align-top">
//   <div className="flex flex-col">
//     {/* Score number on top, left-aligned */}
//     <Tooltip
//       title={
//         <div>
//           <p>Uniqueness: {uniqueness_qs ?? "N/A"}</p>
//           <p>Validity: {validity_qs ?? "N/A"}</p>
//           <p>Freshness: {freshness_qs ?? "N/A"}</p>
//           <p>Consistency: {consistency_qs ?? "N/A"}</p>
//           <p>Completeness: {completeness_qs ?? "N/A"}</p>
//           <p>Accuracy: {accuracy_qs ?? "N/A"}</p>
//         </div>
//       }
//       componentsProps={{
//         tooltip: {
//           sx: {
//             padding: "12px 16px",
//             minHeight: "60px",
//             fontSize: "0.9rem",
//             lineHeight: "1.6",
//             backgroundColor:
//               total_dq_score < 90
//                 ? "#f03e3eff"
//                 : total_dq_score >= 90 && total_dq_score < 95
//                 ? "#FFC100"
//                 : "#009F52",
//           },
//         },
//       }}
//     >
//       <span className="text-left block">
//         {renderHighlightedText(
//           total_dq_score?.toString() ?? "NA",
//         columnSearch.total_dq_score
//         )}
//       </span>
//     </Tooltip>

//     {/* Full background line */}
//     <div className="w-full h-[4px] bg-gray-200 rounded mt-1 relative">
//       <div
//         className="h-[4px] rounded"
//         style={{
//           width: `${total_dq_score ?? 0}%`,
//           backgroundColor:
//             total_dq_score < 90
//               ? "#FB0301"
//               : total_dq_score >= 90 && total_dq_score < 95
//               ? "#FFC100"
//               : "#009F52",
//           position: "absolute",
//           top: 0,
//           left: 0,
//         }}
//       />
//     </div>
//   </div>
// </td>



//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AssetTable;




import React from "react";
import Tooltip from "@mui/material/Tooltip";
import heartLoading from "../../assests/heartLoading.gif";
import { ArrowUp, ArrowDown } from "lucide-react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Search } from "lucide-react";
import Skeleton from "@mui/material/Skeleton";
import preloader from "../../assests/preloader1.gif";




const AssetTable = ({
  tableData = [],
  loading = false,
  assetCount = 0,
  error = null,
  pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
    onSortChange = () => {},
  onPageChange = () => {},
  onColumnSearchChange = () => {},   
  columnSearch = {}, 
}) => {
  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];
    const tableContainerRef = React.useRef(null);
    const [sortColumn, setSortColumn] = React.useState(null);
const [sortOrder, setSortOrder] = React.useState("asc");

const handleResetInputs = () => {
  if (typeof onColumnSearchChange === "function") {
    Object.keys(columnSearch).forEach((col) => onColumnSearchChange(col, ""));
  }
};

const handleSort = (column) => {
  let newOrder = "asc";

  if (sortColumn === column && sortOrder === "asc") {
    newOrder = "desc";
  }

  setSortColumn(column);
  setSortOrder(newOrder);

  if (typeof onSortChange === "function") {
    onSortChange(column, newOrder);
  }
};
  
const renderHighlightedText = (text, searchTerm) => {
  if (!searchTerm || !text) return text;

  const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
  return parts.map((part, i) =>
    part.toLowerCase() === searchTerm.toLowerCase() ? (
      <span key={i} style={{ backgroundColor: "orange", fontWeight: "500" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};


  // if (loading) {
  //   return (
  //     <div
  //       className="flex items-center justify-center w-full overflow-hidden"
  //       style={{ minHeight: "100%", marginTop: "80px" }}
  //     >
  //       <div className="text-center flex flex-col items-center justify-center space-y-4">
  //         <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
  //         <div className="space-y-2">
  //           <p className="text-gray-700 text-xl font-semibold">
  //             Applying filters...
  //           </p>
  //           <p className="text-gray-500 text-base">
  //             Updating results based on your selection
  //           </p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (error) {
    return <div className="p-4 text-red-600">Error: {error}</div>;
  }

  const totalRecords = pagination.totalCount || 0;
  const pageSize = pagination.pageSize || 10;
  const currentPage = pagination.page || 1;
  const totalPages =
    pagination.totalPages && pagination.totalPages > 0
      ? pagination.totalPages
      : Math.max(1, Math.ceil(totalRecords / pageSize));

  const indexOfFirstRow =
    totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const indexOfLastRow =
    totalRecords === 0 ? 0 : Math.min(currentPage * pageSize, totalRecords);

  const gotoPage = (p) => {
    const target = Math.max(1, Math.min(totalPages, p));
    if (target !== currentPage) {
      onPageChange(target);
    }
  };

  return (
    <div className="poppins-regular">
      {/* Header count */}
      {/* <div className="mb-[20px]">
        <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
          THERE ARE {assetCount} ASSETS FOUND
        </span>
      </div> */}

      {/* Score legend */}
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex items-center space-x-8">
          <div className="flex space-x-6">
            {items.map((item, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <div
                  className="w-[14px] h-[50px] rounded-full"
                  style={{ backgroundColor: item.color.trim() }}
                />
                <div className="flex flex-col text-sm text-gray-500">
                  <span style={{ fontSize: "12px" }}>DQ Score</span>
                  <span style={{ fontSize: "12px" }}>{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination (your original code) */}
        <div>
          {totalRecords > 0 && (
            <div className="pagination-controls flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => gotoPage(currentPage - 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Previous
              </button>

              {(() => {
                const pageButtons = [];
                const totalToShow = 5;

                let start = Math.max(
                  1,
                  currentPage - Math.floor(totalToShow / 2)
                );
                let end = start + totalToShow - 1;

                if (end > totalPages) {
                  end = totalPages;
                  start = Math.max(1, end - totalToShow + 1);
                }

                if (start > 1) pageButtons.push(1);
                if (start > 2) pageButtons.push("...");

                for (let i = start; i <= end; i++) {
                  pageButtons.push(i);
                }

                if (end < totalPages - 1) pageButtons.push("...");
                if (end < totalPages) pageButtons.push(totalPages);

                return pageButtons.map((p, idx) =>
                  p === "..." ? (
                    <span key={idx} className="px-2">
                      ...
                    </span>
                  ) : (
                    <button
                      key={idx}
                      onClick={() => gotoPage(p)}
                      className={`px-3 py-1 border rounded ${
                        currentPage === p ? "bg-[#bb1ccc] text-white" : ""
                      }`}
                    >
                      {p}
                    </button>
                  )
                );
              })()}

              <button
                disabled={currentPage === totalPages}
                onClick={() => gotoPage(currentPage + 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
        <div className="flex justify-between items-center">
        {/* Left side items */}
        <div className="flex items-center gap-3 mb-[10px]">
          {/* Search Input */}
        
      
          {/* Reset button */}
          <button className="px-3 mt-[4px]  w-[100px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
          onClick={handleResetInputs}
        
        >
            Reset
          </button>
      
          {/* Scroll section */}
       <div className="flex items-center gap-1 mt-[3px]">
       <ChevronLeft
        title="Scroll Left"
          className="cursor-pointer"
          onClick={() => {
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
            }
          }}
        />
        <p className="text-[12px]">Scroll</p>
        <ChevronRight
          className="cursor-pointer"
          title="Scroll Right"
          onClick={() => {
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
            }
          }}
        />
      </div>
      
        </div>
      
        {/* Right side - Export */}
        <div className="mb-[10px]">
        <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
          THERE ARE {assetCount} UNIQUE ASSETS FOUND
        </span>
      </div>
      </div>

      {/* Table */}
<div
  ref={tableContainerRef}
  className="w-full overflow-x-auto"
  style={{ scrollBehavior: "smooth" }}
>
  <table
    className="border-collapse border border-gray-200 text-sm"
    style={{ minWidth: "max-content", tableLayout: "auto" }}
  >
        
         
<thead className="bg-[#9897FF1A] text-[#404040] font-medium">
  {/* Header Row */}
  <tr>
<th
  onClick={() => handleSort("domain_name")}
  className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
>
  <span className="flex items-center gap-1">
    Domain
    {sortColumn === "domain_name" ? (
      sortOrder === "asc" ? (
        <ArrowUp size={12} />
      ) : (
        <ArrowDown size={12} />
      )
    ) : (
      <ArrowUp size={12} className="opacity-30" />
    )}
  </span>
</th>


<th
      onClick={() => handleSort("sub_domain_name")}
      className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "sub_domain_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Sub Domain
        {sortColumn === "sub_domain_name" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
    <th
      onClick={() => handleSort("product_name")}
      className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "product_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Data Product Name
        {sortColumn === "product_name" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
  <th
      onClick={() => handleSort("region")}
      className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[170px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "region" ? "text-[#0000A0]" : ""
        }`}
      >
        Region
        {sortColumn === "region" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
    <th
      onClick={() => handleSort("data_asset_name")}
      className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "data_asset_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Data Asset Name
        {sortColumn === "data_asset_name" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
    <th
      onClick={() => handleSort("frequency")}
      className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "frequency" ? "text-[#0000A0]" : ""
        }`}
      >
        Frequency
        {sortColumn === "frequency" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
  <th
  onClick={() => handleSort("execution_date")}
  className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
>
  <span
    className={`flex items-center gap-1 ${
      sortColumn === "execution_date" ? "text-[#0000A0]" : ""
    }`}
  >
    Execution Date
    {sortColumn === "execution_date" ? (
      sortOrder === "asc" ? (
        <ArrowUp size={12} />
      ) : (
        <ArrowDown size={12} />
      )
    ) : (
      <ArrowUp size={12} className="opacity-30" />
    )}
  </span>
</th>
  <th
  onClick={() => handleSort("total_dq_score")}
  className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px] cursor-pointer select-none"
>
  <span
    className={`flex items-center gap-1 ${
      sortColumn === "total_dq_score" ? "text-[#0000A0]" : ""
    }`}
  >
    Total DQ Score
    {sortColumn === "total_dq_score" ? (
      sortOrder === "asc" ? (
        <ArrowUp size={12} />
      ) : (
        <ArrowDown size={12} />
      )
    ) : (
      <ArrowUp size={12} className="opacity-30" />
    )}
  </span>
</th>

  </tr>

  {/* Input Row */}
  <tr>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search "
          value={columnSearch.domain_name || ""}
  onChange={(e) => onColumnSearchChange("domain_name", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search "
          value={columnSearch.sub_domain_name || ""}
  onChange={(e) => onColumnSearchChange("sub_domain_name", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search"
          value={columnSearch.product_name || ""}
  onChange={(e) => onColumnSearchChange("product_name", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search "
        value={columnSearch.region || ""}
  onChange={(e) => onColumnSearchChange("region", e.target.value)}

      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search"
          value={columnSearch.data_asset_name || ""}
  onChange={(e) => onColumnSearchChange("data_asset_name", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search"
          value={columnSearch.frequency || ""}
  onChange={(e) => onColumnSearchChange("frequency", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search"
          value={columnSearch.execution_date || ""}
  onChange={(e) => onColumnSearchChange("execution_date", e.target.value)}
      />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input
        className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
        placeholder="Search"
          value={columnSearch.total_dq_score || ""}
  onChange={(e) => onColumnSearchChange("total_dq_score", e.target.value)}
      />
    </th>
  </tr>
</thead>



          <tbody>
         {loading ? (
    [...Array(7)].map((_, i) => (
      <tr key={i}>
        <td className="px-[25px] py-2">
          <Skeleton variant="text" width={100} height={20} />
        </td>

        <td className="px-[25px] py-2">
          <Skeleton variant="text" width={120} height={20} />
        </td>

        <td className="px-[25px] py-2">
          <Skeleton variant="text" width={100} height={20} />
        </td>

        <td className="px-[25px] py-2">
          <Skeleton variant="text"width={120} height={20} />
        </td>

        {/* Data Asset Name */}
        <td className="px-[25px] py-2">
          <Skeleton variant="text" width={130} height={20} />
        </td>

        {/* Frequency */}
        <td className="px-[25px] py-2">
          <Skeleton variant="text" width={100} height={20} />
        </td>

        {/* Execution Date */}
        <td className="px-[25px] py-2">
          <Skeleton variant="text"width={100} height={20} />
        </td>

        {/* Total DQ Score */}
        <td className="px-[25px] py-2">
          <Skeleton variant="rectangular"width="100%" height={20} />
        </td>
      </tr>
    ))
  ) : tableData.length === 0 ? (
    <tr>
      <td colSpan="8" className="text-center py-10 text-gray-500">
        No Data Available
      </td>
    </tr>
  ) : (
              tableData.map((row, idx) => {
                const {
                  domain,
                  sub_domain,
                  data_product_name,
                  region,
                  data_asset_name,
                  frequency,
                  execution_date,
                  total_dq_score,
                  uniqueness_qs,
                  validity_qs,
                  freshness_qs,
                  consistency_qs,
                  completeness_qs,
                  accuracy_qs,
                } = row;

                
                let textColor = "black";
                let tooltipBgColor = "#fff";
                if (total_dq_score != null) {
                  if (total_dq_score < 90) {
                    textColor = "#FB0301";
                    tooltipBgColor = "#f03e3eff";
                  } else if (total_dq_score >= 90 && total_dq_score < 95) {
                    textColor = "#FFC100";
                    tooltipBgColor = "#FFC100";
                  } else if (total_dq_score >= 95) {
                    textColor = "#009F52";
                    tooltipBgColor = "#009F52";
                  }
                }

                const dateStr = execution_date
                  ? new Date(execution_date).toLocaleDateString("en-US", {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                  : "-";

                return (
   <tr key={idx} className={`transition-colors cursor-pointer ${idx % 2 === 0 ? "bg-white" : "#eee"} hover:!bg-[#E4F8F1]`}>

<td className="px-[25px] text-[10px]  text-[#404040] py-2">
  <Tooltip
    title={domain || "-"}
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "10px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block w-[100px] text-[10px]  text-[#404040] truncate">
      {domain ? (
        renderHighlightedText(
          domain.length > 10 ? domain.slice(0, 10) + "..." : domain,
          columnSearch.domain_name
        )
      ) : (
        "-"
      )}
    </span>
  </Tooltip>
</td>

<td className="px-[25px] py-2 text-[10px]  text-[#404040]">
  <Tooltip title={sub_domain || ""}
   slotProps={{
    tooltip: {
      sx: {
          backgroundColor: "#ece5e5ff",
        color: "black",
        fontSize: "10px",
        fontFamily: "Poppins",
        padding: "8px 10px",
        borderRadius: "6px",
        maxWidth: "400px",
        whiteSpace: "pre-wrap",
      },
    },
  }}>
    <span className="truncate block text-[10px]  text-[#404040] w-[120px]">
      {sub_domain
        ? renderHighlightedText(
            sub_domain.length > 15 ? sub_domain.slice(0, 15) + "..." : sub_domain,
            columnSearch.sub_domain_name
          )
        : "null"}
    </span>
  </Tooltip>
</td>
<td className="px-[25px] py-2 text-[10px]  text-[#404040]">
  <Tooltip title={data_product_name || ""}
   slotProps={{
    tooltip: {
      sx: {
          backgroundColor: "#ece5e5ff",
        color: "black",
        fontSize: "10px",
        fontFamily: "Poppins",
        padding: "8px 10px",
        borderRadius: "6px",
        maxWidth: "400px",
        whiteSpace: "pre-wrap",
      },
    },
  }}>
    <span className="truncate block w-[100px] text-[10px]  text-[#404040]">
      {data_product_name
        ? renderHighlightedText(
            data_product_name.length > 15
              ? data_product_name.slice(0, 15) + "..."
              : data_product_name,
            columnSearch.product_name
          )
        : "null"}
    </span>
  </Tooltip>
</td>    <td className="px-[25px] py-2 text-[10px]  text-[#404040]">
  <Tooltip title={region || ""}
   slotProps={{
    tooltip: {
      sx: {
          backgroundColor: "#ece5e5ff",
        color: "black",
        fontSize: "10px",
        fontFamily: "Poppins",
        padding: "8px 10px",
        borderRadius: "6px",
        maxWidth: "400px",
        whiteSpace: "pre-wrap",
      },
    },
  }}>
    <span className="truncate block text-[10px]  text-[#404040] w-[120px]">
      {region
        ? renderHighlightedText(region,columnSearch.region)
        : "null"}
    </span>
  </Tooltip>
</td>

         <td className="px-[25px] text-[10px]  text-[#404040] py-2">
  <Tooltip
    title={
      data_asset_name
        ? data_asset_name.includes("|")
          ? data_asset_name.split("|")[1]
          : data_asset_name
        : ""
    }
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "10px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="truncate text-[10px]  text-[#404040] block w-[130px]">
      {data_asset_name ? (
        renderHighlightedText(
          data_asset_name.includes("|")
            ? data_asset_name.split("|")[1]
            : data_asset_name,
          columnSearch.data_asset_name
        )
      ) : (
        "null"
      )}
    </span>
  </Tooltip>
</td>

                  <td className="px-[25px] text-[10px]  text-[#404040] py-2">
  <span className="w-[100px] text-[10px]  text-[#404040]">
    {frequency
      ? renderHighlightedText(frequency, columnSearch.frequency)
      : "null"}
  </span>
</td>

<td className="px-[25px] py-2 w-[100px] text-[10px] text-[#404040]">
  {dateStr ? (
    renderHighlightedText(
      new Date(dateStr).toLocaleDateString("en-US", {
        month: "short",  // Oct
        day: "numeric",  // 30
        year: "numeric", // 2025
      }),
      columnSearch.execution_date
    )
  ) : (
    "null"
  )}
</td> 
<td className="px-[25px] py-2 text-[10px]  text-[#404040] font-semibold align-top">
  <div className="flex flex-col">
    {/* Score number on top, left-aligned */}
    <Tooltip
      title={
        <div>
          <p>Uniqueness: {uniqueness_qs ?? "N/A"}</p>
          <p>Validity: {validity_qs ?? "N/A"}</p>
          <p>Freshness: {freshness_qs ?? "N/A"}</p>
          <p>Consistency: {consistency_qs ?? "N/A"}</p>
          <p>Completeness: {completeness_qs ?? "N/A"}</p>
          <p>Accuracy: {accuracy_qs ?? "N/A"}</p>
        </div>
      }
      componentsProps={{
        tooltip: {
          sx: {
            padding: "12px 16px",
            minHeight: "60px",
            fontSize: "0.9rem",
            lineHeight: "1.6",
            backgroundColor:
              total_dq_score < 90
                ? "#f03e3eff"
                : total_dq_score >= 90 && total_dq_score < 95
                ? "#FFC100"
                : "#009F52",
          },
        },
      }}
    >
      <span className="text-left block">
        {renderHighlightedText(
          total_dq_score?.toString() ?? "NA",
        columnSearch.total_dq_score
        )}
      </span>
    </Tooltip>

    {/* Full background line */}
    <div className="w-full bg-gray-200 rounded-full h-[8px] mt-1 relative">
  <div
    className="h-[8px] rounded-full transition-all duration-300"
    style={{
      width: `${parseFloat(total_dq_score) || 0}%`,
      backgroundColor:
        total_dq_score >= 95
          ? "#009F52"  // Green
          : total_dq_score >= 90
          ? "#FFC100"  // Yellow
          : "#FB0301", // Red
      position: "absolute",
      top: 0,
      left: 0,
    }}
  />
</div>
  </div>
</td>



                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetTable;

